import styled from "styled-components";
import TableItem from "./tableItem";
import { useEffect, useState } from "react";
import { toNumber } from "../../types/types";
import TableItemExport from "./tableItemExport";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  width: 100%;
  height: 100%;
`;

const InputArea = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  width: 100%;
`;

const TotalArea = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  width: 100%;
  height: 3vw;
`;

const LefSideArea = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 3vw;
  height: 100%;
  border-right: 0.1vw solid #606060;
  border-top: 0.1vw solid #606060;
  font-size: 1.6vw;
  font-weight: 600;
  line-height: 3vw;
  text-align: center;
  padding: 0.4vw;
`;

const RightSideArea = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

const InputRow = styled.div`
  display: flex;
  justify-content: start;
  width: 100%;
  height: 3vw;
`;

const TotalNameArea = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 47.36vw;
  height: 100%;
  border-right: 0.1vw solid #606060;
  border-top: 0.1vw solid #606060;
  background-color: #f4f4f4;
  font-size: 1.8vw;
  font-weight: 500;
`;

const TotalValueArea = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  width: 30.01vw;
  height: 100%;
  border-right: 0.1vw solid #606060;
  border-top: 0.1vw solid #606060;
  font-size: 1.8vw;
  font-weight: 500;
  padding-right: 1vw;
`;

const TotalRemarkArea = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 5.92vw;
  height: 100%;
  border-right: 0.1vw solid #606060;
  border-top: 0.1vw solid #606060;
  font-size: 1.8vw;
  font-weight: 500;
`;

export default function ChargeListTable(props: any) {
  const { data, currentPage, idx, isExport } = props;

  return (
    <Wrapper>
      <InputArea>
        <LefSideArea>
          {idx}.{data.title}
        </LefSideArea>
        <RightSideArea>
          {data.List.map((item: any, index: number) => {
            return (
              <InputRow key={index}>
                <TableItem
                  value={item.name}
                  currentPage={currentPage}
                  idx={index}
                  width={"17.44vw"}
                  type={"string"}
                  readOnly
                ></TableItem>
                <TableItem
                  value={item.spec}
                  currentPage={currentPage}
                  idx={index}
                  width={"15vw"}
                  type={"string"}
                  readOnly
                ></TableItem>
                <TableItem
                  value={item.unit}
                  currentPage={currentPage}
                  idx={index}
                  width={"6vw"}
                  type={"string"}
                  readOnly
                ></TableItem>
                <TableItem
                  value={item.quantity}
                  currentPage={currentPage}
                  idx={index}
                  width={"6vw"}
                  type={"number"}
                  readOnly
                ></TableItem>

                {isExport ? (
                  <>
                    <TableItemExport
                      value={item.unitPrice}
                      currentPage={currentPage}
                      idx={index}
                      width={"15vw"}
                      type={"string"}
                      textAlign={"end"}
                      readOnly
                    ></TableItemExport>
                    <TableItemExport
                      value={item.amount}
                      currentPage={currentPage}
                      idx={index}
                      width={"15vw"}
                      type={"number"}
                      textAlign={"end"}
                      readOnly
                    ></TableItemExport>
                    <TableItemExport
                      value={item.remarks}
                      currentPage={currentPage}
                      idx={index}
                      width={"5.92vw"}
                      type={"string"}
                    ></TableItemExport>
                  </>
                ) : (
                  <>
                    <TableItem
                      value={item.unitPrice}
                      currentPage={currentPage}
                      idx={index}
                      width={"15vw"}
                      type={"number"}
                      textAlign={"end"}
                      readOnly
                    ></TableItem>
                    <TableItem
                      value={item.amount}
                      currentPage={currentPage}
                      idx={index}
                      width={"15vw"}
                      type={"number"}
                      textAlign={"end"}
                      readOnly
                    ></TableItem>
                    <TableItem
                      value={item.remarks}
                      currentPage={currentPage}
                      idx={index}
                      width={"5.92vw"}
                      type={"string"}
                    ></TableItem>
                  </>
                )}
              </InputRow>
            );
          })}
        </RightSideArea>
      </InputArea>
      <TotalArea>
        <TotalNameArea>{data.title} 계</TotalNameArea>
        <TotalValueArea>{data.total}</TotalValueArea>
        <TotalRemarkArea></TotalRemarkArea>
      </TotalArea>
    </Wrapper>
  );
}
